const dotted = (item: string) => `.${item}`

export const MAX_UPLOAD_SIZE = 4 * 1024 ** 3 // 4GB
export const SUPPORTED_IMAGE_TYPES = ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'svg', 'webp']
export const SUPPORTED_VIDEO_TYPES = ['avi', 'flv', 'mkv', 'mov', 'mp4', 'ogg', 'webm', 'wmv']
export const SUPPORTED_IMAGE_EXTENSIONS = SUPPORTED_IMAGE_TYPES.map(dotted)
export const SUPPORTED_VIDEO_EXTENSIONS = SUPPORTED_VIDEO_TYPES.map(dotted)
export const SUPPORTED_UPLOAD_FILE_EXTENSIONS = [
  // documents
  '.pdf',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  // image
  ...SUPPORTED_IMAGE_EXTENSIONS,
  // video
  ...SUPPORTED_VIDEO_EXTENSIONS,
  // fonts - when we support annotations with custom fonts
  // '.woff',
  // '.woff2',
  // '.ttf',
  // AR - usdz
  '.usd',
  '.usdz',
  // web apps
  '.zip',
]

export const SUPPORTED_FONT_TYPES = ['otf', 'ttf', 'woff', 'woff2']
export const SUPPORTED_FONT_EXTENSIONS = SUPPORTED_FONT_TYPES.map(dotted)
